import { Box, Button, useDisclosure, Slide, Heading, Flex, Spacer, Text, InputGroup, Input, Divider, IconButton, InputRightElement, Modal, ModalContent, ModalHeader, ModalBody, useMediaQuery, CircularProgress, Checkbox, Link } from '@chakra-ui/react';
import { useEffect, useState, useRef } from 'react';
import moment from 'moment-timezone';

// Icons
import { IconCheck, IconError, IconInfo } from '../../Assets/GENERALES/Icons';
import { AiOutlineClose } from "react-icons/ai";

// Components
import { postData, postEmail } from '../../Services/api';
import enviroments from '../../Services/enviroments';

const SlideModal = ({ setOpenSlideModal, openSlideModal, id, submitInitial, plan, price, valuePhoneInitial, setValuePhoneInitial, setColorBorderInitial, setViewIconRightInitial, linkRedirect, seccionSelected }) => {
    const [acceptedComunicaciones, setAcceptedComunicaciones] = useState(true);
    const [valuePhone, setValuephone] = useState(valuePhoneInitial);
    const [disabledButton, setDisabledButton] = useState(true);
    const [colorBorder, setColorBorder] = useState('#E4002B');
    const [loadingRetry, setLoadingRetry] = useState(false);
    const [viewIconRight, setViewIconRight] = useState('');
    const [colorLabel, setColorLabel] = useState('black');
    const [duplicidad, setDuplicidad] = useState(false);
    const [textError, setTextError] = useState(false);
    const [accepted, setAccepted] = useState(true);
    const [valueName, setValueName] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(true);
    const [tryAgain, setTryAgain] = useState(0);
    const [info, setInfo] = useState(true);

    const { isOpen: isOpenToggle, onToggle } = useDisclosure();
    const { isOpen, onOpen, onClose } = useDisclosure();

    const [isMobile] = useMediaQuery("(max-width: 768px)");

    const queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);

    const buttonRef = useRef(false);

    let campaignid = urlParams.get('campaignid');
    let adgroupid = urlParams.get('adgroupid');
    let anuncioGroup = urlParams.get('group');
    let keyword = urlParams.get('keyword');
    let origin = urlParams.get('origin');
    let gclid = urlParams.get('gclid');
    let adId = urlParams.get('adId');
    let type = urlParams.get('type');

    let exprecionRegular = /^\+?\d*$/;

    useEffect(() => {
        submitInitial && handleSubmitLead({ retry: false });
    }, []);

    useEffect(() => {
        isMobile ? onToggle() : onOpen();
    }, [isMobile]);

    const handleChangeInput = (value) => {
        if (value.startsWith("+1868") && exprecionRegular.test(value)) {
            setValuephone(value);
            if (value.length > 13 || value.length < 13 || value.length !== 4) {
                setViewIconRight('Error');
                setColorBorder('#DB110A');
                setDisabledButton(true);
                setTextError(true);
            } if (value.length === 12) {
                setViewIconRight('Success');
                setColorBorder('#1EA67B');
                if (valueName !== '' && accepted) {
                    setDisabledButton(false);
                }
                setTextError(false);
            }
        }
    };

    const handleAcceptedChange = (e) => {
        const value = e.target.checked;
        setAccepted(value);
        if (valuePhone.length === 12 && valueName.length > 0 && value) {
            setDisabledButton(false);
        } else {
            setDisabledButton(true);
        }
    };

    const submitLead = async (endpointSave, countAgain, campaignid, adgroupid, keyword, adId, referer) => {
        const submit = await postData(endpointSave, {
            name: valueName === '' ? 'form' : valueName,
            phone: valuePhone,
            plan,
            gclid,
            anuncioGroup,
            origin: 'mobile',
            campaignid,
            adgroupid,
            keyword,
            adId,
            type,
            referer,
            url: window.location.href
        });

        if (submit?.catch) {
            if (countAgain === 3) {
                await postEmail('emails', {
                    telefono_cliente: parseInt(valuePhone.replace('+1868', '')),
                    nombre_cliente: valueName === '' ? 'form' : valueName,
                    tipo_lead: plan,
                    gclid: gclid,
                    origin,
                    fecha: moment().format("DD-MM-YYYY hh:mm a"),
                    error: `${submit?.error} ---------- ${submit?.data} -------- ${submit?.error2}`,
                    landing: "digicel",
                });

                setInfo(false);
                setLoading(false);
                setSuccess(false);
                setDuplicidad(false);
                setLoadingRetry(false);
                
                buttonRef.current = true;
                return true;
            } else {
                return false;
            }
        } else {
            if (submit?.OK === true) {
                if (submit?.STATUS_INSERT === 'error') {
                    if (countAgain === 3) {
                        await postEmail('emails', {
                            telefono_cliente: valuePhone,
                            nombre_cliente: valueName === '' ? 'form' : valueName,
                            tipo_lead: plan,
                            gclid: gclid,
                            origin,
                            fecha: moment().format("DD-MM-YYYY hh:mm a"),
                            error: Object.values(submit?.ERROR).length > 0 ? JSON.stringify(submit?.ERROR) : 'Error',
                            landing: "digicel"
                        });

                        setInfo(false);
                        setLoading(false);
                        setSuccess(false);
                        setDuplicidad(false);
                        
                        buttonRef.current = true;
                        return true;
                    } else {
                        return false;
                    };
                } else {
                    window.dataLayer.push({
                        'event': 'Lead_Movil',
                        'name': valueName,
                        'Phone': valuePhone,
                        'PlanId': id,
                        'origen': 'mobile'
                    });

                    setInfo(false);
                    setLoading(false);
                    setSuccess(true);
                    setDuplicidad(false);

                    if (submitInitial) {
                        setColorBorderInitial('#E4002B');
                        setViewIconRightInitial('');
                        setValuePhoneInitial('');
                    };

                    return true;
                };
            } else {
                if (submit?.STATUS_INSERT === 'duplicidad') {
                    setInfo(false);
                    setLoading(false);
                    setSuccess(false);
                    setDuplicidad(true);
                    if (submitInitial) {
                        setColorBorderInitial('#E4002B');
                        setViewIconRightInitial('');
                        setValuePhoneInitial('');
                    };
                    if (linkRedirect) {
                        window.open(linkRedirect, '_blank');
                    }
                    return true;
                } else {
                    if (countAgain === 3) {
                        await postEmail('emails', {
                            telefono_cliente: parseInt(valuePhone.replace('+1868', '')),
                            nombre_cliente: valueName === '' ? 'form' : valueName,
                            tipo_lead: plan,
                            gclid: gclid,
                            origin,
                            fecha: moment().format("DD-MM-YYYY hh:mm a"),
                            error: Object.values(submit?.ERROR).length > 0 ? JSON.stringify(submit?.ERROR) : 'Error',
                            landing: "digicel"
                        });

                        setInfo(false);
                        setLoading(false);
                        setSuccess(false);
                        setDuplicidad(false);
                        setLoadingRetry(false);
                        
                        buttonRef.current = true;
                        return true;
                    } else {
                        return false;
                    }
                };
            };
        };
    };

    const handleSubmitLead = async ({ retry }) => {
        if (enviroments.urlBase === '') {
            if (!buttonRef.current) {
                buttonRef.current = true;
                setTryAgain(tryAgain + 1);
                setLoadingRetry(true);
                setLoading(true);

                let endpointSave = 'save';

                if (tryAgain === 2) {
                    window.location.reload();
                    return false;
                };

                let countAgain = 0;

                while (countAgain <= 3) {
                    const stateSubmit = await submitLead(endpointSave, countAgain, campaignid, adgroupid, keyword, adId, window.location.href);

                    if (!stateSubmit) {
                        countAgain++
                    } else {
                        buttonRef.current = false;
                        break;
                    }
                }
                setLoadingRetry(false);
            }
        }
    };

    const updateValueName = (e) => {
        const value = e.target.value;
        setValueName(value);
        if (valuePhone.length === 12 && value.length > 0 && accepted) {
            setDisabledButton(false);
        } else {
            setDisabledButton(true);
        }
    };

    return (
        <>
            {
                isMobile
                    ? <Slide direction='bottom' in={isOpenToggle} style={{ zIndex: 10 }}>
                        <Box py='7' px='5' bg='white' borderTopRadius='30px'>
                            {
                                !loading &&
                                <Flex>
                                    <Heading className='Subtitle' color='#E4002B' size='lg'>{info ? 'We help you sign up' : success ? "We've received your application!" : 'Service not available'}</Heading>
                                    <Spacer />
                                    <IconButton color='#E4002B' onClick={() => setOpenSlideModal(!openSlideModal)} variant='link' icon={<AiOutlineClose size='35px' />} _focusVisible={{}} _active={{}} _focus={{}} />
                                </Flex>
                            }

                            {
                                loading
                                    ? <Flex m='auto' justifyContent='center' alignItems='center' my='40'>
                                        <CircularProgress isIndeterminate color='#E4002B' thickness='9px' size='100px' />
                                    </Flex>
                                    : info
                                        ? <>
                                            <Text className='General' mt='4' mb='7'>An agent will contact you as soon as possible</Text>
                                            <Text className="General" color={colorLabel}>Enter your name*</Text>
                                            <Input borderRadius='6px' value={valueName} onChange={(e) => updateValueName(e)} />
                                            <Text className="General" color={colorLabel}>Enter your number*</Text>
                                            <InputGroup bg='white' size='lg'>
                                                <Input className="General" inputMode='tel' maxLength='12' value={valuePhone} borderBottom={viewIconRight !== '' && `2px solid ${colorBorder}`} onBlur={() => { valuePhone === '+1868' && setValuephone(''); setColorLabel('black') }} onChange={(e) => handleChangeInput(e.target.value)} borderRadius='6px' placeholder='Ej: 1234567' onFocus={() => { valuePhone === '' && setValuephone('+1868'); setColorLabel('#E4002B') }} _focusVisible={{ variant: 'flushed', bg: '#F3F5FF', borderBottom: `2px solid ${colorBorder}` }} />
                                                {
                                                    viewIconRight !== '' &&
                                                    <InputRightElement>
                                                        {
                                                            viewIconRight === 'Error' ? <IconError size='20px' /> : <IconCheck size='20px' />
                                                        }
                                                    </InputRightElement>
                                                }
                                            </InputGroup>
                                            {
                                                textError && <Text color='red' className='General' fontSize='sm'>The number of phone is incorrect</Text>
                                            }

                                            <Checkbox mt='4' isChecked={accepted} onChange={handleAcceptedChange} iconColor='white' sx={{ '> span:first-of-type': { bg: accepted ? '#E4002B' : 'white', borderColor: '#E4002B' }, '_checked': { '> span:first-of-type': { bg: '#E4002B', borderColor: '#E4002B' } } }}>
                                                <Text className='General' fontSize='sm'>
                                                    I have read understood and agreed to <Link href='#' target='_blank' color='#E4032C' textDecoration='underline'>Digicel's Privacy Notice</Link>                                                                                                            
                                                </Text>
                                            </Checkbox>

                                            <Checkbox mt='4' isChecked={acceptedComunicaciones} onChange={(e) => setAcceptedComunicaciones(e.target.checked)} iconColor='white' sx={{ '> span:first-of-type': { bg: acceptedComunicaciones ? '#E4002B' : 'white', borderColor: '#E4002B' }, '_checked': { '> span:first-of-type': { bg: '#E4002B', borderColor: '#E4002B' } } }}>
                                                <Text className='General' fontSize='sm'>
                                                    I accept the <Link href='https://corporate.digicelgroup.com/es/terms-of-use' target='_blank' color='#E4032C' textDecoration='underline'>Terms and conditions</Link> and <Link href='https://corporate.digicelgroup.com/en/legal/acceptable-use-policy' target='_blank' color='#E4032C' textDecoration='underline'>Data privacy policy</Link>                                                    
                                                </Text>
                                            </Checkbox>

                                            <Button w='100%' isLoading={loadingRetry} className='Subtitle' id={id} onClick={() => handleSubmitLead({ retry: false })} bg={!disabledButton ? '#E4002B' : 'gray.300'} color={!disabledButton ? 'white' : 'gray.700'} _hover={{}} mt='7' isDisabled={disabledButton} borderRadius='30px' size='lg'>
                                                I want you to call me
                                            </Button>

                                            {/* <Divider h='1px' my='7' />

                                            <Flex bg='#F3F5FF' p='5'>
                                                <IconInfo size='45px' />
                                                <Box ml='4' my='auto'>
                                                    <Text className='Subtitle'>
                                                       Hours of Operation: Monday to Saturday of 7:00 to 20:00 hrs.
                                                    </Text>
                                                </Box>
                                            </Flex> */}
                                        </>
                                        : success
                                            ? <>
                                                <Box>
                                                    <Text className='Subtitle' fontSize='lg'>
                                                        We'll call you soon at the number you provided. We recommend keeping your phone nearby.
                                                    </Text>

                                                    <Flex bg='#F3F5FF' p='2' mt='7' borderRadius='6px' mb='4'>
                                                        <IconInfo size='30px' />
                                                        <Box ml='4' my='auto'>
                                                            <Text className='Subtitle'>
                                                                To provide you with better service, this conversation may be recorded.
                                                            </Text>
                                                        </Box>
                                                    </Flex>
                                                </Box>
                                            </>
                                            : <>
                                                <Box>
                                                    <Text className='Subtitle' mb='2'>
                                                        Unfortunately, we are currently unable to process your request to contact you. Please try again.
                                                    </Text>

                                                    <Button size='lg' w='100%' className='Subtitle' onClick={() => handleSubmitLead({ retry: true })} bg='#E4002B' color='white' _hover={{ bg: 'transparent', color: '#E4002B', border: '2px solid #E4002B' }} my='5' borderRadius='30px'>
                                                        Try again
                                                    </Button>

                                                    <Divider h='1px' mb='5' />
                                                </Box>
                                            </>
                            }
                        </Box>
                    </Slide>
                    : <Modal blockScrollOnMount={false} isOpen={isOpen} closeOnOverlayClick={false} onClose={onClose} size='xl' isCentered>
                        <ModalContent borderRadius='15px' py='2'>
                            <ModalHeader pb='0'>
                                <Flex>
                                    {
                                        !loading && <Heading textAlign={info ? 'left' : 'center'} color='#E4002B' className='Subtitle' size='lg'>{info ? 'We help you sign up' : success ? "We've received your application!" : 'Service not available'}</Heading>
                                    }
                                    <Spacer />
                                    <IconButton color='#E4002B' onClick={() => setOpenSlideModal(!openSlideModal)} variant='link' icon={<AiOutlineClose size='35px' />} _focusVisible={{}} _active={{}} _focus={{}} />
                                </Flex>
                            </ModalHeader>
                            <ModalBody>
                                {
                                    loading
                                        ?
                                        <Flex m='auto' justifyContent='center' alignItems='center' mt='20' mb='40'>
                                            <CircularProgress isIndeterminate color='#E4002B' thickness='9px' size='100px' />
                                        </Flex>
                                        : info
                                            ? <>
                                                <Text className='General' mb='7'>An agent will contact you as soon as possible</Text>

                                                <Text className="General" color={colorLabel}>Enter your name*</Text>
                                                <Input borderRadius='6px' value={valueName} onChange={(e) => updateValueName(e)} />

                                                <Text className="General" mt='3' color={colorLabel}>Enter your number*</Text>
                                                <InputGroup bg='white' size='lg'>
                                                    <Input className="General" inputMode='tel' maxLength='12' value={valuePhone} borderBottom={viewIconRight !== '' && `2px solid ${colorBorder}`} onBlur={() => { valuePhone === '+1868' && setValuephone(''); setColorLabel('black') }} onChange={(e) => handleChangeInput(e.target.value)} borderRadius='6px' placeholder='Ej: 1234567' onFocus={() => { valuePhone === '' && setValuephone('+1868'); setColorLabel('#E4002B') }} _focusVisible={{ variant: 'flushed', bg: '#F3F5FF', borderBottom: `2px solid ${colorBorder}` }} />
                                                    {
                                                        viewIconRight !== '' &&
                                                        <InputRightElement>
                                                            {
                                                                viewIconRight === 'Error' ? <IconError size='20px' /> : <IconCheck size='20px' />
                                                            }
                                                        </InputRightElement>
                                                    }
                                                </InputGroup>
                                                {
                                                    textError && <Text color='red' className='General' fontSize='sm'>The number of phone is incorrect</Text>
                                                }

                                                <Checkbox mt='4' isChecked={accepted} onChange={handleAcceptedChange} iconColor='white' sx={{ '> span:first-of-type': { bg: accepted ? '#E4002B' : 'white', borderColor: '#E4002B' }, '_checked': { '> span:first-of-type': { bg: '#E4002B', borderColor: '#E4002B' } } }}>
                                                    <Text className='General' fontSize='sm'>
                                                        I have read understood and agreed to <Link href='#' target='_blank' color='#E4032C' textDecoration='underline'>Digicel's Privacy Notice</Link>                                                        
                                                    </Text>
                                                </Checkbox>

                                                <Checkbox mt='4' isChecked={acceptedComunicaciones} onChange={(e) => setAcceptedComunicaciones(e.target.checked)} iconColor='white' sx={{ '> span:first-of-type': { bg: acceptedComunicaciones ? '#E4002B' : 'white', borderColor: '#E4002B' }, '_checked': { '> span:first-of-type': { bg: '#E4002B', borderColor: '#E4002B' } } }}>
                                                    <Text className='General' fontSize='sm'>
                                                        I accept the <Link href='https://corporate.digicelgroup.com/es/terms-of-use' target='_blank' color='#E4032C' textDecoration='underline'>Terms and conditions</Link> and <Link href='https://corporate.digicelgroup.com/en/legal/acceptable-use-policy' target='_blank' color='#E4032C' textDecoration='underline'>Data privacy policy</Link>                                                    
                                                    </Text>
                                                </Checkbox>

                                                <Button w='70%' className='Subtitle' mx='auto' id={id} display='flex' onClick={() => handleSubmitLead({ retry: false })} bg={!disabledButton ? '#E4002B' : 'gray.300'} color={!disabledButton ? 'white' : 'gray.700'} _hover={{ bg: 'transparent', color: '#E4002B', border: '2px solid #E4002B' }} my='5' isDisabled={disabledButton} borderRadius='30px' size='lg'>
                                                    I want you to call me
                                                </Button>

                                                {/* <Divider h='1px' mb='7' /> */}

                                                {/* <Flex bg='#F3F5FF' p='2' mt='7'>
                                                    <IconInfo size='30px' />
                                                    <Box ml='4' my='auto'>
                                                        <Text className='Subtitle'>
                                                            Hours of operation: Monday through Saturday, 7:00 a.m. to 20:00 p.m.
                                                        </Text>
                                                    </Box>
                                                </Flex> */}

                                            </>
                                            : success
                                                ? <>
                                                    <Box>
                                                        <Text mt='7' className='Subtitle'>
                                                            We'll call you soon at the number you provided. We recommend keeping your phone nearby.
                                                        </Text>

                                                        <Flex bg='#F3F5FF' p='2' mt='7' borderRadius='6px'>
                                                            <IconInfo size='30px' />
                                                            <Box ml='4' my='auto'>
                                                                <Text className='Subtitle'>
                                                                    To provide you with better service, this conversation may be recorded.
                                                                </Text>
                                                            </Box>
                                                        </Flex>
                                                    </Box>
                                                </>
                                                : duplicidad
                                                    ? <>
                                                        <Box>
                                                            <Text mt='7' className='Subtitle'>
                                                                You have already submitted a request for us to contact you. We have received your information and will call you as soon as possible.
                                                            </Text>

                                                            <Flex bg='#F3F5FF' p='2' mt='4' borderRadius='6px'>
                                                                <IconInfo size='30px' />
                                                                <Box ml='4' my='auto'>
                                                                    <Text className='Subtitle'>
                                                                        To provide you with better service, this conversation may be recorded.
                                                                    </Text>
                                                                </Box>
                                                            </Flex>
                                                        </Box>
                                                    </>
                                                    : <>
                                                        <Box>
                                                            <Text mt='7' className='Subtitle'>
                                                                Unfortunately, we are currently unable to process your request to contact you. Please try again.
                                                            </Text>

                                                            <Button size='lg' isLoading={loadingRetry} w='70%' onClick={() => handleSubmitLead({ retry: true })} className='Subtitle' mx='auto' display='flex' bg='#E4002B' color='white' _hover={{ bg: 'transparent', color: '#E4002B', border: '2px solid #E4002B' }} my='7' borderRadius='30px'>
                                                                Try again
                                                            </Button>

                                                            <Divider h='1px' mb='7' />
                                                        </Box>
                                                    </>
                                }
                            </ModalBody>
                        </ModalContent>
                    </Modal>
            }
        </>
    )
};

export default SlideModal;